import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import moment from 'moment';
import Select from 'react-select';
import ApiService from '../../../INVENTORY/services/apiService';
import ApiService2 from '../../../POS/services/apiService';
import '../../../POS/component/pages/menus/addItems/addmenu.css'
import { ClipLoader, FadeLoader } from 'react-spinners';
import { getName, getUserId } from '../../../Redux/selecters';
import { useSelector } from 'react-redux';
import { FaAngleLeft } from "react-icons/fa6";
import Modal from 'react-bootstrap/Modal';
const IMAGE_URL = process.env.REACT_APP_IMAGE_URL

const UpdateitemList = (props) => {
    let navigate = useNavigate();
    const location = useLocation();
    const val = location?.state;
    const [subCategoryOptions, setSubCategoryOptions] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [DirectPurchase, setDirectPurchase] = useState(false);
    const [unitMeasurement, setunitMeasurement] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [packingUom, setPackingUOMOptions] = useState([]);
    const [FinishGood, setFinishGoods] = useState(false);
    const [packingType, setPackingType] = useState([]);
    const [stockType, setStockType] = useState([]);
    const [Service, setService] = useState(false);
    const [loading, setLoading] = useState(false);
    const [Assests, setAssets] = useState(false);
    const [sales, setSales] = useState(false);
    const [supplier, setSupplier] = useState([]);
    const [Active, setActive] = useState(false);
    const [loader, setLoader] = useState(false);
    const [vat, setvat] = useState([]);
    const userName = useSelector(getName);
    const [accounts, setAccounts] = useState();
    const userId = useSelector(getUserId);
    const [ItemCode, setItemCode] = useState()
    const [itemDetais, setItemDetais] = useState(true);
    const [glDetails, setglDetails] = useState(false);
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [attachmentList, setAttachmentList] = useState([
        { rcno: null, srno: 0, fileName: '', remarks: '' },
    ]);
    const handleClose = () => setAttachmentModal(false);
    const handleOpen = () => setAttachmentModal(true);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [formData, setFormData] = useState({
        itemNo: '',
        recordId: '',
        Vat: [],
        volume: '',
        length: "",
        width: "",
        description: "",
        PackingUnitMeasurement: [],
        InventoryUom: [],
        Supplier: [],
        PackingType: [],
        height: "",
        fixedAsset: "",
        purchasePrice: 0,
        area: "",
        address: "",
        weight: "",
        Category: [],
        SubCategory: [],
        StockType: [],
        enableLoyalty: true,
        adjustmentAccount: "",
        grnAccount: "",
        cgsAccount: "",
        wastageAccount: "",
        InventoryAccounts: "",
        address02: "",
        status: true,
        creationDate: "",
        size: '',
        shape: '',
        reorderLevel: "",
        salePrice: 0,
        minLevel: 0,
        thickness: 0,
        maxLevel: 0,
        convToInvUOM: '',
        remarks: ''
    })
    const resetFormData = () => {
        setAttachmentList([{ id: Date.now(), fileName: '', remarks: '' }]);
        setFormData({
            itemNo: '',
            recordId: '',
            Vat: [],
            volume: '',
            length: "",
            width: "",
            description: "",
            PackingUnitMeasurement: [],
            InventoryUom: [],
            Supplier: [],
            PackingType: [],
            height: "",
            fixedAsset: "",
            purchasePrice: 0,
            area: "",
            address: "",
            weight: "",
            Category: [],
            SubCategory: [],
            StockType: [],
            enableLoyalty: true,
            adjustmentAccount: "",
            grnAccount: "",
            cgsAccount: "",
            wastageAccount: "",
            InventoryAccounts: "",
            address02: "",
            status: true,
            creationDate: "",
            size: '',
            shape: '',
            reorderLevel: "",
            salePrice: 0,
            minLevel: 0,
            thickness: 0,
            maxLevel: 0,
            convToInvUOM: '',
            remarks: ''
        });
        setAssets(false)
        setActive(true)
        setItemCode()
    };
    useEffect(() => {
        const item = location.state;
        const setData = async () => {
            try {
                setLoading(true)
                const apiService = new ApiService();
                let iparam = `?IsActive=true`;
                let packparam = `?Exp2=true`;
                // let Catparam = `?Active=1`;
                // Fetch vat options
                let vatParam = `?toPurchase=true`
                const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
                setvat(vat.data?.result);
                // Fetch inventory UOM options
                const unitMeasurementResponse = await apiService.getApiParamater("GET_EUNIT_MEASUREMENT", iparam);
                setunitMeasurement(unitMeasurementResponse?.data?.result);
                setPackingUOMOptions(unitMeasurementResponse?.data?.result);
                // Fetch Supplier options
                const SupplierRes = await apiService.getApiParamater("GET_SUPPLIER", iparam);
                setSupplier(SupplierRes?.data?.result);
                // Fetch category options
                const categoryResponse = await apiService.get("GET_CATEGORY");
                setCategoryOptions(categoryResponse?.data?.result);
                // Fetch packing type options
                const packingResponse = await apiService.getApiParamater("GET_EPACKING", packparam);
                setPackingType(packingResponse?.data?.result);
                // Fetch stock type options
                const stockType = await apiService.getApiParamater("GET_STOCK_TYPE", iparam);
                setStockType(stockType?.data?.result);
                // Fetch packing UOM options
                const selectedCategory = categoryResponse?.data?.result?.find(cat => cat?.catCode === item?.category);
                let param = `?isActive=true&Catcode=${selectedCategory?.catCode}`
                const subCategoryResponse = await apiService.getApiParamater("GET_SUB_CATEGORY", param);
                let glparam = `?ItemNo=${item?.itemNo}`
                setSubCategoryOptions(subCategoryResponse?.data?.result)
                const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", glparam);
                setItemCode(item?.itemNo)
                let attachparam = `?DocNo=${item?.itemNo}&DocType=${"Item Master"}`;
                const AttachmentResponse = await apiService.getApiParamater("GET_ATTACHMENT", attachparam);
                const existingAttachments = AttachmentResponse?.data?.result || [];
                const latestSrno = existingAttachments.length > 0
                    ? Math.max(...existingAttachments?.map((attachment) => attachment.srno))
                    : 0;

                const updatedAttachments = [
                    ...existingAttachments,
                    { rcno: null, srno: latestSrno + 1, fileName: '', remarks: '' },
                ];
                const accountResponse = await apiService.get('GET_ACCOUNTS');
                setAccounts([{ value: null, accountName: 'None' }, ...(accountResponse?.data?.result || [])]);
                setAttachmentList(updatedAttachments);
                let itemGl = getGLAccounts?.data?.result?.[0] || []
                const selectedVat = vat.data?.result?.find(v => v.description === item?.vat);
                const selectedSuplier = SupplierRes?.data?.result?.find(sp => sp?.supplier_ID === item?.supplier);
                const selectedSuplierName = SupplierRes?.data?.result?.find(sp => sp?.supplierName === item?.supplier);
                const selectedPackingType = packingResponse?.data?.result?.find(pt => pt?.description === item?.packingType);
                const selectedSubCategory = subCategoryResponse.data.result?.find(cat => cat?.subcatcode === item?.subCategory);
                const selectedStocktype = stockType?.data?.result?.find(stock => stock?.stockTypeCode === item?.stockType);
                const selectedInvUOM = unitMeasurementResponse?.data?.result?.find(InventoryUM => InventoryUM?.description === item?.unitMeasurement);
                const selectedPUM = unitMeasurementResponse?.data?.result?.find(p => p?.description === item?.baseUnit);
                let selectedInvntory = null;
                let selectedAdjustmentAccount = null;
                let selectedgrnAccount = null;
                let selectedcgsAccount = null;
                let selectedwastageAccount = null;
                if (itemGl?.inventoryAccountCode) {
                    selectedInvntory = accountResponse?.data?.result?.find(inv => inv.accountCode === itemGl?.inventoryAccountCode);
                }
                if (itemGl?.adjustmentAccountCode) {
                    selectedAdjustmentAccount = accountResponse?.data?.result?.find(adj => adj.accountCode === itemGl?.adjustmentAccountCode);
                }
                if (itemGl?.grnAccountCode) {
                    selectedgrnAccount = accountResponse?.data?.result?.find(adj => adj.accountCode === itemGl?.grnAccountCode);
                }
                if (itemGl?.cgsAccountCode) {
                    selectedcgsAccount = accountResponse?.data?.result?.find(adj => adj.accountCode === itemGl?.cgsAccountCode);
                }
                if (itemGl?.wastageAccountCode) {
                    selectedwastageAccount = accountResponse?.data?.result?.find(adj => adj.accountCode === itemGl?.wastageAccountCode);
                }
                setFormData({
                    description: item?.itemDescription || "",
                    itemNo: item?.recordId || "",
                    volume: item?.volume || '',
                    length: item?.length || '',
                    width: item?.width || '',
                    thickness: item?.thickness || '',
                    height: item?.height || "",
                    createdOn: moment(item?.createdOn).format("YYYY-MM-DD") || "",
                    weight: item?.weight || "",
                    purchasePrice: item?.purchasePrice || "",
                    area: item?.area || "",
                    address: item?.address || "",
                    size: item?.size || "",
                    shape: item?.shape || "",
                    enableLoyalty: item?.enableLoyalty || 0,
                    minLevel: item?.minLevel || 0,
                    maxLevel: item?.maxLevel || 0,
                    reorderLevel: item?.reorderLevel,
                    salePrice: parseInt(formData?.salePrice),
                    convToInvUOM: item?.convToInvUOM || 0,
                    Vat: { label: selectedVat?.description, value: selectedVat },
                    PackingType: { label: selectedPackingType?.description, value: selectedPackingType },
                    Supplier: { label: selectedSuplier?.supplierName || selectedSuplierName?.supplierName, value: selectedSuplier || selectedSuplierName },
                    Category: { label: selectedCategory?.catName, value: selectedCategory },
                    SubCategory: { label: selectedSubCategory?.subcatname, value: selectedSubCategory },
                    StockType: { label: selectedStocktype?.stockTypeName, value: selectedStocktype },
                    InventoryUom: { label: selectedInvUOM?.description, value: selectedInvUOM },
                    PackingUnitMeasurement: { label: selectedPUM?.description, value: selectedPUM },
                    adjustmentAccount: { label: selectedAdjustmentAccount?.accountName, value: selectedAdjustmentAccount },
                    grnAccount: { label: selectedgrnAccount?.accountName, value: selectedgrnAccount },
                    cgsAccount: { label: selectedcgsAccount?.accountName, value: selectedcgsAccount },
                    wastageAccount: { label: selectedwastageAccount?.accountName, value: selectedwastageAccount },
                    InventoryAccounts: { label: selectedInvntory?.accountName, value: selectedInvntory },
                    remarks: item?.remarks1
                });

                const isFixedAsset = item?.fixedAsset === "True";
                const isInventory = item?.inventory === "True";
                setAssets(isFixedAsset);
                // Service is only when BOTH inventory and fixedAsset are false
                setService(!isFixedAsset && !isInventory);
                setDirectPurchase(item?.purchased === "True" ? true : false)
                setSales(item?.sales === "True" || item?.sales === "true" ? true : false)
                setActive(item?.exp9 === "1" ? true : false)
                setLoading(false)
            } catch (error) {
                setLoading(false)
                console.error('Error:', error);
            }
            setLoading(false)
        }
        if (item) {
            setData()
        }
    }, [location?.state]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value === "") {
            setFormData({
                ...formData,
                [name]: value,
                [`${name}IsValid`]: false,
            });
            return;
        }
        if (name === "convToInvUOM" && value < 1) {
            return;
        }
        setFormData({
            ...formData,
            [name]: value,
            [`${name}IsValid`]: value > 0,
        });
    };
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "Category") {
            const selectedInvntory = accounts?.find(inv => inv.accountCode === value?.value?.inventoryAccountCode)
            const selectedAdjustmentAccount = accounts?.find(adj => adj.accountCode === value?.value?.adjustmentAccountCode)
            const selectedgrnAccount = accounts?.find(adj => adj.accountCode === value?.value?.grnAccountCode)
            const selectedcgsAccount = accounts?.find(adj => adj.accountCode === value?.value?.cgsAccountCode)
            const selectedwastageAccount = accounts?.find(adj => adj.accountCode === value?.value?.wastageAccountCode)
            setFormData({
                ...formData,
                Category: value,
                adjustmentAccount: { label: selectedAdjustmentAccount?.accountName, value: selectedAdjustmentAccount },
                grnAccount: { label: selectedgrnAccount?.accountName, value: selectedgrnAccount },
                cgsAccount: { label: selectedcgsAccount?.accountName, value: selectedcgsAccount },
                wastageAccount: { label: selectedwastageAccount?.accountName, value: selectedwastageAccount },
                InventoryAccounts: { label: selectedInvntory?.accountName, value: selectedInvntory },
                SubCategory: []

            });
            handleSubcat(value)
        } else if (name === "SubCategory") {
            const selectedInvntory = accounts?.find(inv => inv.accountCode === value?.value?.inventoryAccountCode)
            const selectedAdjustmentAccount = accounts?.find(adj => adj.accountCode === value?.value?.adjustmentAccountCode)
            const selectedgrnAccount = accounts?.find(adj => adj.accountCode === value?.value?.grnAccountCode)
            const selectedcgsAccount = accounts?.find(adj => adj.accountCode === value?.value?.cgsAccountCode)
            const selectedwastageAccount = accounts?.find(adj => adj.accountCode === value?.value?.wastageAccountCode)
            setFormData({
                ...formData,
                adjustmentAccount: formData?.adjustmentAccount?.value ? formData?.adjustmentAccount : { label: selectedAdjustmentAccount?.accountName, value: selectedAdjustmentAccount },
                grnAccount: formData?.grnAccount?.value ? formData?.grnAccount : { label: selectedgrnAccount?.accountName, value: selectedgrnAccount },
                cgsAccount: formData?.cgsAccount?.value ? formData?.cgsAccount : { label: selectedcgsAccount?.accountName, value: selectedcgsAccount },
                wastageAccount: formData?.wastageAccount?.value ? formData?.wastageAccount : { label: selectedwastageAccount?.accountName, value: selectedwastageAccount },
                InventoryAccounts: formData?.InventoryAccounts?.value ? formData?.InventoryAccounts : { label: selectedInvntory?.accountName, value: selectedInvntory },
                SubCategory: value
            });
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleActiveSelection = (e) => {
        setActive(e);
    }
    const handleDirectPurchaseSelection = (e) => {
        setDirectPurchase(e);
    }
    const handleAssetsSelection = (e) => {
        setAssets(e);
    }
    const handleSalesSelection = (e) => {
        setSales(e);
    }
    const handleFinishGoodSelection = (e) => {
        setFinishGoods(e);
    }
    const handleServiceSelection = (e) => {
        setService(e);
    }
    const handleSubcat = async (selectedOption) => {
        try {
            const apiService = new ApiService();
            let param = `?Active=1&Catcode=${selectedOption?.value.catCode}`;
            const subCategoryResponse = await apiService.getApiParamater("GET_SUB_CATEGORY", param);
            const subCategoryOptions = subCategoryResponse?.data?.result
            setSubCategoryOptions(subCategoryOptions);
        } catch (error) {
            console.error('Error:', error);
        }
    };
    const handleUpdateItem = async (e) => {
        e.preventDefault();
        setLoader(true)
        // if (!formData?.Vat) {
        //   toast.warning("Enter Select VAT")
        //   setLoader(false)
        //   return;
        // } else
        if (!formData?.description) {
            toast.warning("Enter Description")
            setLoader(false)
            return;
        } else if (!formData?.InventoryUom?.label) {
            toast.warning("Enter Inventory Uom")
            setLoader(false)
            return;
            // } else if (!formData?.PackingType?.label) {
            //   toast.warning("Enter Select Packing Type")
            //   setLoader(false)
            //   return;
        } else if (!formData?.Category?.value?.catCode) {
            toast.warning("Enter Select Category")
            setLoader(false)
            return;
        } else if (!formData?.PackingUnitMeasurement?.label) {
            toast.warning("Enter Packing UOM")
            setLoader(false)
            return;
        } else if (!formData?.SubCategory?.value?.subcatcode) {
            toast.warning("Enter Select Sub Category")
            setLoader(false)
            return;
            // } else if (!formData?.StockType?.value?.stockTypeCode) {
            //   toast.warning("Enter Select Stock Type")
            //   setLoader(false)
            //   return;
        } else if (!formData?.convToInvUOM) {
            toast.warning("Enter Enter Conversion Rate")
            setLoader(false)
            return;
        }
        try {
            const body = {
                recordId: val?.recordId,
                itemNo: ItemCode,
                itemDescription: formData?.description,
                purchasePrice: parseInt(formData?.purchasePrice || 0),
                salePrice: parseInt(formData?.salePrice),
                minLevel: parseInt(formData?.minLevel),
                maxLevel: parseInt(formData?.maxLevel),
                supplier: formData?.Supplier?.value?.supplier_ID || '',
                vat: formData?.Vat?.value?.description || "",
                category: formData?.Category?.value?.catCode.toString(),
                subCategory: formData?.SubCategory?.value?.subcatcode.toString(),
                stockType: formData?.StockType?.value?.stockTypeCode.toString(),
                unitMeasurement: formData?.InventoryUom?.label || "",
                packingType: formData?.PackingType?.label || "",
                size: formData?.size,
                shape: formData?.shape,
                weight: formData?.weight,
                exp9: Active === true ? "1" : "0",
                finish: FinishGood === true ? "True" : "False",
                purchased: DirectPurchase === true ? "True" : "False",
                fixedAsset: Assests ? "True" : "False",
                // Inventory is true only when NOT Service and NOT Fixed Asset
                inventory: (!Service && !Assests) ? "True" : "False",
                sales: sales === true ? "True" : "False",
                loggedInUser: userId,
                width: formData?.width,
                thickness: formData?.thickness,
                height: formData?.height,
                length: formData?.length,
                volume: formData?.volume,
                reorderLevel: formData?.reorderLevel,
                convToInvUOM: formData?.convToInvUOM,
                packingUOM: formData?.PackingUnitMeasurement?.label,
                inventoryAcCode: formData?.InventoryAccounts?.value?.accountCode || "",
                inventoryAcName: formData?.InventoryAccounts?.label || "",
                grnAcCode: formData?.grnAccount?.value?.accountCode || "",
                grnAcName: formData?.grnAccount?.label || "",
                remarks1: formData?.remarks,
                invoiceAcName: "0",
                invoiceAcCode: "0",
                cgsAcCode: formData?.cgsAccount?.value?.accountCode || "",
                cgsAcName: formData?.cgsAccount?.label || "",
                adjAcCode: formData?.adjustmentAccount?.value?.accountCode || "",
                adjAcName: formData?.adjustmentAccount?.label || "",
                wastageAccountCode: formData?.wastageAccount?.value?.accountCode || "",
                wastageAccountName: formData?.wastageAccount?.label || "",
                workInProgressAccountCode: "0",
                workInProgressAccountName: "0",
                issueAccountCode: "0",
                issueAccountName: "0",
            }

            const glBody = {
                itemNo: ItemCode,
                inventoryAccountCode: formData?.InventoryAccounts?.value?.accountCode || '',
                inventoryAccountName: formData?.InventoryAccounts?.label === "None" ? '' : formData?.InventoryAccounts?.label || '',
                grnAccountCode: formData?.grnAccount?.value?.accountCode || '',
                grnAccountName: formData?.grnAccount?.label === "None" ? '' : formData?.grnAccount?.label || '',
                invoiceAccountCode: "0",
                invoiceAccountName: "0",
                cgsAccountCode: formData?.cgsAccount?.value?.accountCode || '',
                cgsAccountName: formData?.cgsAccount?.label === "None" ? '' : formData?.cgsAccount?.label || '',
                adjustmentAccountCode: formData?.adjustmentAccount?.value?.accountCode || '',
                adjustmentAccountName: formData?.adjustmentAccount?.label === "None" ? '' : formData?.adjustmentAccount?.label || '',
                wastageAccountCode: formData?.wastageAccount?.value?.accountCode || '',
                wastageAccountName: formData?.wastageAccount?.label === "None" ? '' : formData?.wastageAccount?.label || '',
                workInProgressAccountCode: "0",
                workInProgressAccountName: "0",
                issueAccountCode: "0",
                issueAccountName: "0",
            }
            const apiService = new ApiService();
            let response = await apiService.put("UPDATE_ITEM", body);
            let GLResponse = await apiService.put("UPDATE_ITEM_GL", glBody);

            if (GLResponse?.data?.statusCode === 208) {
                let GLResponse = await apiService.post("CREATE_ITEM_GL", glBody);
            }
            const formdata = new FormData();
            attachmentList.forEach((attachment) => {
                if (attachment.file) {
                    formdata.append('Images', attachment.file);
                }
            });

            const ImgResponse = await apiService.postMultiPart("UPLOAD_FILE", formdata);
            if (ImgResponse.data?.statusCode === 201 && ImgResponse.data?.isSuccessful) {
                const uploadedFileNames = ImgResponse.data?.result.split(',');
                const docFilesDtos = attachmentList
                    .filter((attachment) => {
                        return attachment.fileName && attachment.rcno && attachment.srno && attachment.remarks;
                    })
                    .map((attachment, index) => {
                        let fileName = attachment.fileName;
                        if (attachment.file) {
                            fileName = uploadedFileNames[index]?.trim();
                        }
                        return {
                            rcno: attachment?.rcno,
                            srno: attachment?.srno,
                            docNo: ItemCode,
                            docType: "Item Master",
                            fileName: fileName,
                            remarks: attachment.remarks || ""
                        };
                    });

                const AttachmentData = { docFilesDtos, docNo: ItemCode };
                const attachmentResponse = await apiService.put("UPDATE_ATTACHMENT", AttachmentData);
            }
            if (response.data.statusCode === 201) {
                setLoader(false)
                toast.success(response?.data?.message);
                resetFormData();
                navigate("/inventory/Master/Item")
            } else if (response?.data?.statusCode === 400) {
                setLoader(false)
                toast.warning(response?.data?.message);
            } else if (response?.data?.statusCode === 208) {
                toast?.error(response?.data?.message)
                setLoader(false)
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error(error.res.data.message)
            setLoader(false)
        }
    }
    const handleBackClick = () => {
        window.history.back();
    };
    const handleFileSelect = (event, index) => {
        const file = event.target.files[0];
        if (file) {
            setAttachmentList((prevList) => {
                const updatedList = prevList.map((attachment, idx) =>
                    idx === index
                        ? { ...attachment, fileName: file.name, file: file }
                        : attachment
                );
                if (!updatedList.some((item) => item.fileName === '')) {
                    updatedList.push({ rcno: null, srno: updatedList.length, fileName: '', remarks: '' });
                }

                return updatedList;
            });
        }
    };
    const handleRemarksChange = (value, index) => {
        setAttachmentList((prevList) =>
            prevList.map((attachment, idx) =>
                idx === index ? { ...attachment, remarks: value } : attachment
            )
        );
    };
    const handleView = (file) => {
        if (val) {
            if (file) {
                setPreviewImage(file);
                setPreviewModal(true);
            } else {
                console.error("No valid file to preview");
            }
        } else {
            if (file && file instanceof File) {
                setPreviewImage(URL.createObjectURL(file));
                setPreviewModal(true);
            } else {
                console.error("No valid file to preview");
            }
        }
    };
    const handleDelete = (index) => {
        setAttachmentList((prevList) => {
            const updatedList = prevList.filter((_, idx) => idx !== index);
            if (!updatedList.some((item) => item.fileName === '')) {
                updatedList.push({ rcno: null, srno: updatedList.length, fileName: '', remarks: '' });
            }
            return updatedList;
        });
    };

    return (
        <div className='p-5'>
            <div className='d-flex justify-contant-between '>
                <h5 className='col mainInvHead'>Update Item</h5>
                <div className='d-flex justify-content-end gap-1'>
                    <div className=''>
                        <>{loader === true ?
                            <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <>{val?.eye === true ? "" :
                                <button className='mainbtn ' onClick={handleUpdateItem} type="submit">Update</button>
                            }</>
                        }
                        </>
                    </div>
                    <button onClick={handleBackClick} className='mainbtn'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className=''>
                <form class="row g-3 needs-validation" novalidate>
                    <div className="cost-center-section mb-2">
                        <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                            onClick={() => setItemDetais(!itemDetais)}>
                            <div className='h6 pt-1'>Item Detais</div>
                        </div>
                        <div className={`slide-content ${itemDetais ? 'open' : 'closed'}`}>
                            {loading && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                        background: 'rgba(255,255,255,0.6)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 10,
                                    }}
                                >
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            )}
                            <div className="border-box2 p-3">
                                <div className="form-group justify-content-between row pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom01" className="form-label  pt-1 start">Item No </label>
                                        <input
                                            type="text"
                                            className="form-Input w-100"
                                            name="ItemCode"
                                            disabled
                                            value={ItemCode}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="vat" className="form-label  pt-1 start">VAT </label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-100 p-0" id='vat' required
                                            value={formData?.Vat}
                                            isDisabled={val?.eye === true ? true : false}
                                            onChange={(selectedOption) => handleDropDownChange({ name: 'Vat', value: selectedOption })}
                                            options={vat?.map((vat) => ({ value: vat, label: `${vat?.description}` }))}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom15" className="form-label  pt-1 start">Volume</label>
                                        <input
                                            type="text"
                                            className="form-Input w-100"
                                            disabled={val?.eye === true ? true : false}
                                            id="validationCustom15"
                                            name="volume"
                                            value={formData?.volume}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom02" className="form-label  pt-1 start">Length</label>
                                        <input
                                            type="text"
                                            className="form-Input w-100"
                                            id="validationCustom02"
                                            disabled={val?.eye === true ? true : false}
                                            name="length"
                                            value={formData?.length}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row justify-content-between pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom07" className="form-label  pt-1 start">Description *</label>
                                        <input
                                            type="text"
                                            className="form-Input w-100"
                                            id="description"
                                            disabled={val?.eye === true ? true : false}
                                            name="description" required
                                            value={formData?.description}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">Inventory UOM *</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-100 p-0" required
                                            isDisabled={val?.eye === true ? true : false}
                                            value={formData?.InventoryUom}
                                            onChange={(selectedOption) => handleDropDownChange({ name: 'InventoryUom', value: selectedOption })}
                                            options={unitMeasurement?.map((UM) => ({ value: UM, label: UM?.description }))}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom13" className="form-label  pt-1 start">Thickness</label>
                                        <input
                                            type="text"
                                            className="form-Input w-100 noscroll"
                                            disabled={val?.eye === true ? true : false}
                                            id="validationCustom13"
                                            name="thickness"
                                            value={formData?.thickness}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="col-3   d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Height</label>
                                        <input
                                            type="text"
                                            className="form-Input w-100 noscroll"
                                            disabled={val?.eye === true ? true : false}
                                            id="validationCustom08"
                                            name="height"
                                            value={formData?.height}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row justify-content-between pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            Supplier
                                        </label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9,
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-100 p-0"
                                            isDisabled={val?.eye === true ? true : false}
                                            value={formData?.Supplier}
                                            onChange={(selectedOption) => handleDropDownChange({ name: 'Supplier', value: selectedOption })}
                                            options={supplier?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            Packing type
                                        </label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            isDisabled={val?.eye === true ? true : false}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-100 p-0"
                                            value={formData?.PackingType}
                                            onChange={(selectedOption) => handleDropDownChange({ name: 'PackingType', value: selectedOption })}
                                            options={packingType?.map((packing) => ({ value: packing, label: packing?.description }))}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom13" className="form-label  pt-1 start">Reorder Level</label>
                                        <input
                                            type="number"
                                            min={0}
                                            onWheel={(e) => e.target.blur()}
                                            className="form-Input w-100"
                                            id="validationCustom13"
                                            disabled={val?.eye === true ? true : false}
                                            name="reorderLevel"
                                            value={formData?.reorderLevel}
                                            onChange={handleInputChange}
                                            onKeyDown={preventNegativeSign}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Size</label>
                                        <input
                                            type="text"
                                            className="form-Input w-100"
                                            id="validationCustom08"
                                            disabled={val?.eye === true ? true : false}
                                            name="size"
                                            value={formData?.size}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row justify-content-between pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            Category *
                                        </label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            isDisabled={val?.eye === true ? true : false}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-100 p-0"
                                            value={formData?.Category}
                                            onChange={(selectedOption) => handleDropDownChange({ name: 'Category', value: selectedOption })}
                                            options={categoryOptions?.map((CatOpt) => ({ value: CatOpt, label: CatOpt?.catName }))}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            packing UOM *
                                        </label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            isDisabled={val?.eye === true ? true : false}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-100 p-0"
                                            value={formData?.PackingUnitMeasurement}
                                            onChange={(selectedOption) => handleDropDownChange({ name: 'PackingUnitMeasurement', value: selectedOption })}
                                            options={packingUom?.map((packing) => ({ value: packing, label: packing.description }))}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom13" className="form-label  pt-1 start">Max QTY</label>
                                        <input
                                            type="number"
                                            min={0}
                                            onWheel={(e) => e.target.blur()}
                                            className="form-Input w-100"
                                            disabled={val?.eye === true ? true : false}
                                            id="validationCustom13"
                                            name="maxLevel"
                                            value={formData?.maxLevel}
                                            onChange={handleInputChange}
                                            onKeyDown={preventNegativeSign}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Shape</label>
                                        <input
                                            type="text"
                                            className="form-Input w-100"
                                            disabled={val?.eye === true ? true : false}
                                            id="validationCustom08"
                                            name="shape"
                                            value={formData?.shape}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row justify-content-between pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            Sub Category *
                                        </label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            isDisabled={val?.eye === true ? true : false}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-100 p-0"
                                            value={formData?.SubCategory}
                                            onChange={(selectedOption) => handleDropDownChange({ name: 'SubCategory', value: selectedOption })}
                                            options={subCategoryOptions?.map((SubCatOpt) => ({ value: SubCatOpt, label: SubCatOpt?.subcatname }))}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom13" className="form-label  pt-1 start">Sale Price</label>
                                        <input
                                            type="number" min={0}
                                            onWheel={(e) => e.target.blur()}
                                            className="form-Input w-100"
                                            disabled
                                            id="validationCustom13"
                                            name="salePrice"
                                            value={formData?.salePrice}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Min QTY</label>
                                        <input
                                            type="number" min={0}
                                            className="form-Input w-100"
                                            disabled={val?.eye === true ? true : false}
                                            onWheel={(e) => e.target.blur()}
                                            id="validationCustom08"
                                            name="minLevel"
                                            value={formData?.minLevel}
                                            onChange={handleInputChange}
                                            onKeyDown={preventNegativeSign}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Weight</label>
                                        <input
                                            type="text"
                                            className="form-Input w-100"
                                            disabled={val?.eye === true ? true : false}
                                            id="validationCustom08"
                                            name="weight"
                                            value={formData?.weight}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row justify-content-between pb-3">
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom17" className="form-label  pt-1 start">
                                            Stock Type
                                        </label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            isDisabled={val?.eye === true ? true : false}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-100 p-0"
                                            value={formData?.StockType}
                                            onChange={(selectedOption) => handleDropDownChange({ name: 'StockType', value: selectedOption })}
                                            options={stockType?.map((Stock) => ({ value: Stock, label: Stock?.stockTypeName }))}
                                        />
                                    </div>
                                    <div className="col-3 d-flex justify-content-between">
                                        <label htmlFor="validationCustom13" className="form-label  pt-1 start">Purchase Price</label>
                                        <input
                                            type="number" min={0}
                                            className="form-Input w-100"
                                            onWheel={(e) => e.target.blur()}
                                            id="validationCustom13"
                                            disabled
                                            name="purchasePrice"
                                            value={formData?.purchasePrice}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="col-3  d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">Width</label>
                                        <input
                                            type="text"
                                            className="form-Input w-100"
                                            disabled={val?.eye === true ? true : false}
                                            id="validationCustom08"
                                            name="width"
                                            value={formData?.width}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className='col-1'></div>
                                    <div disabled={val?.eye === true ? true : false} className="col-2 brderbox center p-2" onClick={() => handleOpen()} >
                                        {'Attachment'}
                                    </div>
                                </div>
                                <div className="form-group row  pb-3">
                                    <div className="col-3  d-flex justify-content-between">
                                        <label htmlFor="validationCustom08" className="form-label  pt-1 start">
                                            {formData?.PackingUnitMeasurement?.value?.description}{"   "}
                                            {formData?.PackingUnitMeasurement?.value?.description ? '    =' : ''}
                                        </label>
                                        <input
                                            type='number' min={1}
                                            onWheel={(e) => e.target.blur()}
                                            className="form-Input w-100"
                                            id="convToInvUOM"
                                            name="convToInvUOM"
                                            placeholder='Conversion Rate'
                                            disabled={val?.eye === true ? true : false}
                                            value={formData?.convToInvUOM}
                                            onChange={handleInputChange}
                                            onKeyDown={preventNegativeSign}
                                        />
                                    </div>
                                    <div className='col-3 d-flex gap-5'>
                                        <label htmlFor="validationCustom08" className="form-label pt-1 start">{formData?.InventoryUom?.value?.description}</label>
                                        <div className="form-check">
                                            <input
                                                style={{ width: "20px", height: "20px" }}
                                                disabled={val?.eye === true ? true : false}
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={Service}
                                                id="Service" name="Service"
                                                onChange={(e) => handleServiceSelection(e.target.checked)}
                                            />
                                            <label className="form-check-label mx-2 mt-1">
                                                Service
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 d-flex justify-content-between">
                                        <div className='gap-3 d-flex'>
                                            <div className="form-check">
                                                <input
                                                    style={{ width: "20px", height: "20px" }}
                                                    disabled={val?.eye === true ? true : false}
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={Assests}
                                                    id="Assest" name="Assest"
                                                    onChange={(e) => handleAssetsSelection(e.target.checked)}
                                                />
                                                <label className="form-check-label mx-2 mt-1">
                                                    Fixed assets
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    style={{ width: "20px", height: "20px" }}
                                                    disabled={val?.eye === true ? true : false}
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={sales}
                                                    id="sales" name="sales"
                                                    onChange={(e) => handleSalesSelection(e.target.checked)}
                                                />
                                                <label className="form-check-label mx-2 mt-1">
                                                    Sales
                                                </label>
                                            </div>
                                        </div>
                                        <div className='gap-3 '>
                                            <input className="form-check-input"
                                                type="checkbox"
                                                id="DirectPurchase" style={{ width: "20px", height: "20px" }}
                                                name="DirectPurchase"
                                                disabled={val?.eye === true ? true : false}
                                                checked={DirectPurchase}
                                                onChange={(e) => handleDirectPurchaseSelection(e.target.checked)} />
                                            <label className='px-2 pt-1'>Direct Purchase</label>
                                        </div>
                                        <div className='gap-3 '>
                                            <div className="form-check">
                                                <input
                                                    style={{ width: "20px", height: "20px" }}
                                                    disabled={val?.eye === true ? true : false}
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={Active}
                                                    id="Active" name="Active"
                                                    onChange={(e) => handleActiveSelection(e.target.checked)}
                                                />
                                                <label className="form-check-label mx-2 mt-1">Active</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section">
                        <div className="d-flex cursor-pointer slide-header gap-4"
                            onClick={() => setglDetails(!glDetails)}>
                            <div className='h6 pt-1'>GL Accounts</div>
                        </div>
                        <div className={`slide-content ${glDetails ? 'open' : 'closed'}`}>
                            <div className="border-box2 p-3">
                                <div className='row'>
                                    <div className="col-lg-6">
                                        <div className="form-group row  pb-3">
                                            <div className="col-md-6 d-flex justify-content-between mb-3">
                                                <label htmlFor="validationCustom03" className="form-label pt-1 start">Inventory Account</label>
                                                <Select
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                    isDisabled={val?.eye === true ? true : false}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        option: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                            color: state.isFocused ? '#000 ' : '#000',
                                                            ':hover': {
                                                                backgroundColor: '#F5F5F5',
                                                                color: '#000 ',
                                                            },
                                                        }),
                                                    }}
                                                    className="w-100 p-0"
                                                    value={formData?.InventoryAccounts}
                                                    onChange={(selectedOption) => handleDropDownChange({ name: 'InventoryAccounts', value: selectedOption })}
                                                    options={accounts?.map((sup) => ({ value: sup, label: sup?.accountName }))}
                                                    menuPlacement="auto"
                                                    menuShouldScrollIntoView={false}
                                                />
                                            </div>
                                            <div className="col-md-6  d-flex justify-content-between mb-3">
                                                <label htmlFor="validationCustom04" className="form-label  pt-1 start">CGS</label>
                                                <Select
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                    isDisabled={val?.eye === true ? true : false}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        option: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                            color: state.isFocused ? '#000 ' : '#000',
                                                            ':hover': {
                                                                backgroundColor: '#F5F5F5',
                                                                color: '#000 ',
                                                            },
                                                        }),
                                                    }}
                                                    className="w-100 p-0"
                                                    value={formData?.cgsAccount}
                                                    onChange={(selectedOption) => handleDropDownChange({ name: 'cgsAccount', value: selectedOption })}
                                                    options={accounts?.map((sup) => ({ value: sup, label: sup?.accountName }))}
                                                    menuPlacement="auto"
                                                    menuShouldScrollIntoView={false}
                                                />
                                            </div>
                                            <div className="col-md-6 d-flex justify-content-between">
                                                <label htmlFor="validationCustom05" className="form-label  pt-1 start">Wastage Account</label>
                                                <Select
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                    isDisabled={val?.eye === true ? true : false}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        option: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                            color: state.isFocused ? '#000 ' : '#000',
                                                            ':hover': {
                                                                backgroundColor: '#F5F5F5',
                                                                color: '#000 ',
                                                            },
                                                        }),
                                                    }}
                                                    className="w-100 p-0"
                                                    value={formData?.wastageAccount}
                                                    onChange={(selectedOption) => handleDropDownChange({ name: 'wastageAccount', value: selectedOption })}
                                                    options={accounts?.map((sup) => ({ value: sup, label: sup?.accountName }))}
                                                    menuPlacement="auto"
                                                    menuShouldScrollIntoView={false}
                                                />
                                            </div>
                                            <div className="col-md-6 d-flex justify-content-between">
                                                <label htmlFor="validationCustom12" className="form-label  pt-1 start">GRN Account</label>
                                                <Select
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                    isDisabled={val?.eye === true ? true : false}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        option: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                            color: state.isFocused ? '#000 ' : '#000',
                                                            ':hover': {
                                                                backgroundColor: '#F5F5F5',
                                                                color: '#000 ',
                                                            },
                                                        }),
                                                    }}
                                                    className="w-100 p-0"
                                                    value={formData?.grnAccount}
                                                    onChange={(selectedOption) => handleDropDownChange({ name: 'grnAccount', value: selectedOption })}
                                                    options={accounts?.map((sup) => ({ value: sup, label: sup?.accountName }))}
                                                    menuPlacement="auto"
                                                    menuShouldScrollIntoView={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group d-flex gap-3 pb-3">
                                            <label htmlFor="validationCustom03" className="form-label  pt-1 start">Remarks</label>
                                            <input
                                                type="text"
                                                className="form-Input w-50"
                                                name="remarks"
                                                value={formData?.remarks}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <div className="w-50 d-flex justify-content-between gap-3">
                                                <label htmlFor="validationCustom12" className="form-label  pt-1 start">Adjustment Account</label>
                                                <Select
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        option: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                            color: state.isFocused ? '#000 ' : '#000',
                                                            ':hover': {
                                                                backgroundColor: '#F5F5F5',
                                                                color: '#000 ',
                                                            },
                                                        }),
                                                    }}
                                                    className="w-100 p-0"
                                                    value={formData?.adjustmentAccount}
                                                    onChange={(selectedOption) => handleDropDownChange({ name: 'adjustmentAccount', value: selectedOption })}
                                                    options={accounts?.map((sup) => ({ value: sup, label: sup?.accountName }))}
                                                    menuPlacement="auto"
                                                    menuShouldScrollIntoView={false}
                                                />
                                            </div>
                                            <div className='gap-3 pt-1'>
                                                <input className="form-check-input"
                                                    type="checkbox"
                                                    id="DirectPurchase" style={{ width: "20px", height: "20px" }}
                                                    name="DirectPurchase"
                                                    checked={DirectPurchase}
                                                    onChange={(e) => handleDirectPurchaseSelection(e.target.checked)} />
                                                <label className='px-2 pt-1'>Direct Purchase</label>
                                            </div>
                                            <div className='gap-3 pt-1' >
                                                <input className="form-check-input"
                                                    type="checkbox"
                                                    id="FinishGood" style={{ width: "20px", height: "20px" }}
                                                    name="FinishGood"
                                                    checked={FinishGood}
                                                    onChange={(e) => handleFinishGoodSelection(e.target.checked)} />
                                                <label className='px-2 pt-1'>Finish Good</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div>
                <Modal show={attachmentModal} size="lg" onHide={handleClose} >
                    <Modal.Header closeButton>
                        <Modal.Title>Attachments</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="col-3 d-flex justify-content-between">
                            <label htmlFor="docNp" className="form-label  pt-2 start">Document No</label>
                            <input disabled value={ItemCode} className="form-Input w-100" />
                        </div>
                        <div className="pt-2">
                            <table>
                                <thead className="dynoTable">
                                    <tr>
                                        <th>File Name</th>
                                        <th>Remarks</th>
                                        <th>Upload</th>
                                        <th>View</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attachmentList.map((attachment, index) => (
                                        <tr key={index}>
                                            <td>
                                                <input
                                                    type="text"
                                                    disabled
                                                    value={attachment.fileName}
                                                    style={{ width: '320px' }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    value={attachment.remarks}
                                                    onChange={(e) => handleRemarksChange(e.target.value, index)}
                                                    style={{ width: '345px' }}
                                                />
                                            </td>
                                            <td>
                                                <button
                                                    className="mainbtn"
                                                    onClick={() => document.getElementById(`fileInput-${index}`).click()}
                                                >
                                                    Upload
                                                </button>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleFileSelect(e, index)}
                                                    id={`fileInput-${index}`}
                                                />
                                            </td>
                                            <td>
                                                <button
                                                    className="mainbtnRed"
                                                    onClick={() => handleView(attachment.file || attachment.fileName)}
                                                    disabled={!attachment.fileName}
                                                >
                                                    View
                                                </button>
                                            </td>
                                            <td>
                                                <button
                                                    onClick={() => handleDelete(index)}
                                                    disabled={attachment.fileName === '' && attachment.rcno === null}
                                                    className="mainbtnSecondary"
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='mainbtn ' onClick={handleClose} >Attach</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}
                    backdrop="static"
                    keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Image Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {val?.itemNo ?
                            <>
                                {previewImage && <img src={IMAGE_URL + previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                            </> :
                            <>
                                {previewImage && <img src={previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                            </>
                        }
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    )
}
export default UpdateitemList